(function () {
  'use strict';

  function initSection(section) {
    const detailsElements = section.querySelectorAll('.index-faq__details');
    if (!detailsElements.length) return;

    detailsElements.forEach(function (details) {
      const summary = details.querySelector('.index-faq__summary');
      const content = details.querySelector('.index-faq__content');

      if (!summary) return;

      details.addEventListener('toggle', function () {
        const isOpen = details.open;
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (content) {
          content.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        }
      });

      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && details.open) {
          e.preventDefault();
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
          if (content) {
            content.setAttribute('aria-hidden', 'true');
          }
          summary.focus();
        }
      });
    });

    const allowMultiple = section.getAttribute('data-allow-multiple') !== 'false';

    if (!allowMultiple) {
      detailsElements.forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (details.open) {
            detailsElements.forEach(function (otherDetails) {
              if (otherDetails !== details && otherDetails.open) {
                otherDetails.open = false;
                const otherSummary = otherDetails.querySelector('.index-faq__summary');
                const otherContent = otherDetails.querySelector('.index-faq__content');
                if (otherSummary) {
                  otherSummary.setAttribute('aria-expanded', 'false');
                }
                if (otherContent) {
                  otherContent.setAttribute('aria-hidden', 'true');
                }
              }
            });
          }
        });
      });
    }
  }

  function init() {
    document.querySelectorAll('.index-faq[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
